import React, { CSSProperties, RefObject, useRef } from 'react';

import { useParticles } from '../../../utils/hooks/useParticlesClient';

interface Props {
    contentRef: RefObject<HTMLElement>;
}

export const QuizStudentParticles = ({ contentRef }: Props) => {
    const particlesRef = useRef<HTMLCanvasElement>(null);

    useParticles(particlesRef, contentRef);

    const style: CSSProperties = {
        pointerEvents: 'none',
        position: 'absolute',
    };

    return <canvas ref={particlesRef} style={style} />;
};
